import { motion } from "framer-motion";

const CHAPTERS = [
    {
        number: "01",
        title: "BORN ON THE ICE",
        text: "Game-used hockey sticks — snapped in the third period, retired from the rink — get a second life at the grill. Every handle still carries its battle scars.",
    },
    {
        number: "02",
        title: "ENFORCER QUALITY",
        text: "A heavy-gauge stainless blade, laser-engraved and serrated, with a bottle opener cut right into the neck. Built to flip, chop, and open.",
    },
    {
        number: "03",
        title: "SKATE LACE LOOP",
        text: "Finished with an authentic pro skate-lace hang loop in red, white, black, or blue. Pick your colour, hang it by the grill, enforce accordingly.",
    },
];

const STATS = [
    { label: "Sticks Recycled", value: "100+" },
    { label: "Flip Accuracy", value: "99.8%" },
    { label: "Blade Gauge", value: "2.5mm" },
    { label: "Order Method", value: "IG DM" },
];

const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    show: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: { delay: i * 0.12, duration: 0.8, ease: [0.16, 1, 0.3, 1] },
    }),
};

export default function Manifesto() {
    return (
        <section
            data-testid="manifesto-section"
            className="relative border-t border-[#2A2A36] bg-[#0A0A0C] px-5 py-20 sm:px-10 sm:py-28 lg:px-16"
        >
            <div className="noise-layer" />
            <div className="mx-auto max-w-[1380px]">
                <motion.p
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true }}
                    className="font-jbmono mb-6 text-[10px] uppercase tracking-[0.3em] text-[#38BDF8] sm:text-xs"
                >
                    03 — THE MANIFESTO
                </motion.p>
                <motion.h2
                    variants={fadeUp}
                    custom={1}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true }}
                    className="font-cond max-w-3xl text-4xl font-extrabold uppercase leading-[0.9] tracking-tight text-[#F2F2F7] sm:text-6xl"
                >
                    From the rink <span className="text-outline">to the grill.</span>
                </motion.h2>

                <div className="mt-14 grid gap-px border border-[#2A2A36] bg-[#2A2A36] sm:mt-20 lg:grid-cols-3">
                    {CHAPTERS.map((c, i) => (
                        <motion.article
                            key={c.number}
                            data-testid={`manifesto-chapter-${c.number}`}
                            variants={fadeUp}
                            custom={i}
                            initial="hidden"
                            whileInView="show"
                            viewport={{ once: true, margin: "-60px" }}
                            className="group relative bg-[#0D0D11] p-8 transition-colors duration-300 hover:bg-[#121216] sm:p-10"
                        >
                            <span className="font-cond text-outline block text-7xl font-extrabold leading-none transition-all duration-300 group-hover:[-webkit-text-stroke-color:rgba(255,59,48,0.6)] sm:text-8xl">
                                {c.number}
                            </span>
                            <h3 className="font-cond mt-6 text-2xl font-bold uppercase tracking-wide text-[#F2F2F7] sm:text-3xl">
                                {c.title}
                            </h3>
                            <p className="mt-4 text-sm leading-relaxed text-[#A1A1B2]">
                                {c.text}
                            </p>
                        </motion.article>
                    ))}
                </div>

                <div className="mt-14 grid grid-cols-2 gap-px border border-[#2A2A36] bg-[#2A2A36] sm:mt-20 lg:grid-cols-4">
                    {STATS.map((s, i) => (
                        <motion.div
                            key={s.label}
                            data-testid={`stat-${s.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                            variants={fadeUp}
                            custom={i}
                            initial="hidden"
                            whileInView="show"
                            viewport={{ once: true }}
                            className="bg-[#0D0D11] p-6 sm:p-8"
                        >
                            <span className="font-cond block text-4xl font-extrabold text-[#FF3B30] sm:text-5xl">
                                {s.value}
                            </span>
                            <span className="font-jbmono mt-2 block text-[10px] uppercase tracking-[0.25em] text-[#A1A1B2]">
                                {s.label}
                            </span>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
